import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-career-container',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './career-container.component.html',
  styleUrl: './career-container.component.scss'
})
export class CareerContainerComponent {

}
